export default __webpack_public_path__ + "97f2b2adc165b85e7f4fc091bf07dcbd.png";